'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GiftLink = exports.GiftLinkUnwrapped = exports.mapStateToProps = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactInlinesvg = require('react-inlinesvg');

var _reactInlinesvg2 = _interopRequireDefault(_reactInlinesvg);

var _reactIntl = require('react-intl');

var _reactRedux = require('react-redux');

var _reactRouter = require('react-router');

var _memberStatus = require('enums/memberStatus');

var _user = require('redux/saga/selectors/user');

var _decorator = require('helpers/decorator');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state) {
  return {
    isActive: (0, _memberStatus.memberStatus)('ACTIVE', (0, _user.memberStatus)(state))
  };
};

var GiftLinkUnwrapped = exports.GiftLinkUnwrapped = function GiftLinkUnwrapped(_ref) {
  var isActive = _ref.isActive;
  return _react2.default.createElement(
    'li',
    { className: (0, _classnames2.default)('header__gifts', {
        'header__gifts--attention': isActive
      })
    },
    _react2.default.createElement(
      _reactRouter.Link,
      { to: '/gifts?ref=header_click' },
      _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'header.link.gifts',
        defaultMessage: 'Gifts'
      }),
      isActive && _react2.default.createElement(_reactInlinesvg2.default, { key: 'gift-green', className: 'svg', src: require('../../../../static/img/icon/gift-green.svg') })
    )
  );
};

GiftLinkUnwrapped.propTypes = {
  isActive: _propTypes2.default.bool.isRequired
};

var GiftLink = exports.GiftLink = (0, _decorator.decorateWith)((0, _reactRedux.connect)(mapStateToProps), (0, _decorator.withName)('GiftLink'))(GiftLinkUnwrapped);